import React, { useState } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import { Panel, PanelHeader, PanelBody, PanelFooter } from "./../../components/panel/panel.jsx";
import { useDispatch, useSelector } from "react-redux";
import { talonarioActions } from "../../store";
import TablaParametrosTalonario from "./components/TablaParametrosTalonario";
import SweetAlert from "react-bootstrap-sweetalert";
import _ from "lodash";

const xhr = new XMLHttpRequest();

const camposDisponibles = [
    { value: "razonsocial", label: "RAZON SOCIAL" },
    { value: "direccion", label: "DIRECCION" },
    { value: "fecha_emision", label: "FECHA EMISION" },
    { value: "registro", label: "REGISTRO" },
    { value: "nit", label: "NIT" },
    { value: "giro", label: "GIRO" },

    { value: "suma_venta_sujeta", label: "SUMA VENTA SUJETA" },
    { value: "iva", label: "IMPUESTO (IVA)" },
    { value: "subtotal", label: "SUBTOTAL" },
    { value: "retencion", label: "IVA RETENIDO" },

    { value: "suma_venta_excenta", label: "SUMA VENTA EXCENTA" },
    { value: "suma_venta_no_sujeta", label: "SUMA VENTA NO SUJETA" },

    { value: "importe", label: "IMPORTE" },
    { value: "importe_enletras", label: "Importe en letras" },

    { value: "items", label: "ITEMS COMPROBANTE" },
    { value: "items.cantidad", label: "ITEMS -> CANTIDADES" },
    { value: "items.descripcion", label: "ITEMS -> DESCRIPCION" },
    { value: "items.precio_unitario", label: "ITEMS -> PRECIO UNITARIO" },
    { value: "items.venta_excenta", label: "ITEMS -> VENTAS EXCENTAS" },
    { value: "items.venta_no_sujeta", label: "ITEMS -> VENTAS NO SUJETA" },
    { value: "items.venta_sujeta", label: "ITEMS -> VENTAS SUJETA" },

    { value: "n_comprobante", label: "CORRELATIVO" },

    { value: "fecha_emision.dia", label: "Fecha emision -> dia" },
    { value: "fecha_emision.mes", label: "Fecha emision -> mes numero" },
    { value: "fecha_emision.mes_letras", label: "Fecha emision -> mes letras" },

    { value: "fecha_emision.ano", label: "Fecha emision -> año" },
];

const DatosTalonario = () => {
    const { talonario_id } = useParams();

    const dispatch = useDispatch();

    const talonario = useSelector((state) => state.talonario.items[talonario_id]) || {};
    const tipocomprobantes = useSelector((state) => state.tipocomprobantes.items) || [];
    const [detalleInput, setDetalleInput] = useState({
        campo: "fecha_emision",
        top: "",
        left: "",
        width: "",
        border: "",
        lineHeight: "",
    });
    const handleInputDetalle = (event) => setDetalleInput({ ...detalleInput, [event.target.name]: event.target.value });
    const [editRowIndex, setEditRowIndex] = useState(-1);
    const [detalle, setDetalle] = useState(talonario.template ? JSON.parse(talonario.template) : []);

    const history = useHistory();

    const [datos, setDatos] = useState({
        id: talonario_id == 0 ? null : talonario_id,
        serie: talonario.serie || "",
        proximo_correlativo: talonario.proximo_correlativo || "",
        ultimo_correlativo: talonario.ultimo_correlativo || "",
        tipoComprobanteId: talonario.tipoComprobanteId || 1,
        predeterminado: talonario.predeterminado || false,
        dte: talonario.dte || false,
        activo: talonario.activo || false,
        template: talonario.template,
        template_path: talonario.template_path,
        template_witdh: talonario.template_witdh,
        template_height: talonario.template_height,
    });

    const handleInputChange = (event) => {
        setDatos({ ...datos, [event.target.name]: event.target.value });
    };

    const handleCheckboxChange = (event) => {
        setDatos({ ...datos, [event.target.name]: !datos[event.target.name] });
    };

    const handleSave = async (event) => {
        event.preventDefault();
        const apiUrl = talonario_id == 0 ? "/api/talonario/registrar" : "/api/talonario/actualizar";
        const response = await fetch(apiUrl, {
            method: talonario_id == 0 ? "POST" : "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ ...datos, template: JSON.stringify(detalle) }),
        });
        if (response.ok) {
            let talonariosRes = await response.json();
            dispatch(talonarioActions.update(_.isArray(talonariosRes) ? talonariosRes : [talonariosRes]));
            history.push("/parametros/talonario");
        } else {
            throw Error(await response.text());
        }
    };

    const handleInputAdd = () => {
        let detalleFiltered = _.omitBy(detalleInput, (v) => v == "");
        setDetalle(detalle.concat(detalleFiltered));
        setDetalleInput({ campo: "fecha_emision", top: "", left: "", width: "", border: "", lineHeight: "" });
    };

    const handleInputEdit = () => {
        detalle[editRowIndex] = _.omitBy(detalleInput, (v) => v == "");
        setDetalle(detalle);
        setDetalleInput({ campo: "fecha_emision", top: "", left: "", width: "", border: "", lineHeight: "" });
        setEditRowIndex(-1);
    };

    const ActionRowHandler = (action, value) => {
        if (action === "remove") {
            setDetalle(_.filter(detalle, (e, i) => i != value));
        } else if (action === "update") {
            setDetalleInput({ ...{ top: "", left: "", width: "", border: "", lineHeight: "" }, ...detalle[value] });
            setEditRowIndex(value);
        }
    };

    var templateChild;
    const loadTemplate = () => {
        templateChild = window.open("", "_blank", "width=830,height=770,left=500");
        let htmlOut = buildTemplate(detalle);
        templateChild.document.write(htmlOut);
    };

    const buildTemplate = (attrs) => {
        let parentNode = document.createElement("body");
        parentNode.style.backgroundImage = `url('/api/file/download/${datos.template_path}')`;
        parentNode.style.backgroundSize = `${datos.template_witdh}cm ${datos.template_height}cm`;
        parentNode.style.backgroundRepeat = `no-repeat`;
        parentNode.style.backgroundColor = "#cccccc";
        parentNode.style.margin = "0";

        let attrsItemsChild = _(attrs)
            .filter((v) => _.startsWith(v.campo, "items."))
            .map((v) => ({ ...v, ["campo"]: v.campo.replaceAll("items.", "") }))
            .value();
        let attrsFijos = _.reject(attrs, (v) => _.startsWith(v.campo, "items."));

        _.each(attrsFijos, (attr) => {
            let newDiv = document.createElement("div");
            newDiv.setAttribute("id", attr.campo);
            newDiv.style.position = "fixed";
            newDiv.style.top = attr.top + "cm";
            newDiv.style.left = attr.left + "cm";
            newDiv.style.width = attr.width + "cm";
            newDiv.style.border = attr.border + "px solid black";
            if (attr.lineHeight) newDiv.style.lineHeight = attr.lineHeight + "cm";
            if (attr.campo == "items") {
                newDiv.style.display = "table";
            } else {
                newDiv.textContent = attr.data || attr.campo;
            }
            parentNode.appendChild(newDiv);
        });

        let newDivItem = document.createElement("div");
        newDivItem.style.display = "table-row";
        _.each(attrsItemsChild, (col, i) => {
            let newDiv = document.createElement("div");
            newDiv.setAttribute("id", `item-${i}-${col.campo}`);
            newDiv.style.display = "table-cell";
            newDiv.style.padding = "0.1em";
            newDiv.style.width = col.width + "cm";
            // newDiv.style.border = col.border + "px solid black";
            if (col.lineHeight) newDiv.style.lineHeight = col.lineHeight + "cm";
            newDiv.textContent = col.campo.replace("_", " ");
            newDivItem.appendChild(newDiv);
        });
        parentNode.querySelector("#items")?.appendChild(newDivItem);

        return parentNode.outerHTML;
    };

    const [file, setFile] = useState();
    const [isUploadingFile, setIsUploadingFile] = useState(false);
    const [percentCompleteFile, setPercentCompleteFile] = useState(0);

    const saveFile = (e) => {
        setFile(e.target.files[0]);
    };

    const uploadFile = async (e) => {
        const formData = new FormData();
        formData.append("invoice", file);
        formData.append("talonario_id", talonario_id);

        xhr.open("POST", "/api/file/upload");
        setIsUploadingFile(true);
        xhr.upload.addEventListener("progress", (e) => {
            setPercentCompleteFile((e.loaded / e.total) * 100);
        });

        xhr.addEventListener("load", () => {
            let res = JSON.parse(xhr.response);
            if (xhr.status == 200) setDatos({ ...datos, ["template_path"]: res.fileName });
            setIsUploadingFile(false);
            setPercentCompleteFile(0);
        });

        ["close", "cancel", "abort"].forEach((e) => {
            xhr.addEventListener(e, () => {
                setIsUploadingFile(false);
                setPercentCompleteFile(0);
            });
        });

        if (xhr.readyState == 1) {
            xhr.send(formData);
        } else {
            console.log("Connection is not opened - readyState:" + xhr.readyState);
        }
    };

    return (
        <div>
            <ol className="breadcrumb float-xl-end">
                <li className="breadcrumb-item">
                    <Link to="/parametros/talonario">Talonarios</Link>
                </li>
                <li className="breadcrumb-item active">Datos de talonarios</li>
            </ol>
            <h1 className="page-header">Datos de talonario</h1>

            <div className="row mb-3">
                <div className="col-xl-12">
                    <Panel>
                        <PanelHeader>Talonario: {talonario?.serie || " Nuevo registro"}</PanelHeader>

                        {isUploadingFile ? (
                            <SweetAlert
                                title="Cargando archivo"
                                confirmBtnText="Cancelar"
                                confirmBtnBsStyle="danger"
                                onConfirm={() => xhr.abort()}>
                                <div>
                                    <div className="row">
                                        <div className="widget-chart-info-progress">
                                            <span className="float-start">Subiendo...</span>
                                            <span className="float-end">{Math.round(percentCompleteFile)}%</span>
                                        </div>
                                    </div>
                                    <div className="progress h-10px">
                                        <div
                                            className="progress-bar progress-bar-striped progress-bar-animated rounded-pill"
                                            style={{ width: `${percentCompleteFile}%` }}></div>
                                    </div>
                                </div>
                            </SweetAlert>
                        ) : null}

                        <PanelBody>
                            <div className="row mb-md-4">
                                <div className="col-md-6">
                                    <div className="form-floating mb-3 mb-md-0">
                                        <input
                                            type="text"
                                            className="form-control fs-15px"
                                            placeholder="2022ST000"
                                            onChange={handleInputChange}
                                            name="serie"
                                            value={datos.serie || ""}
                                        />
                                        <label className="d-flex align-items-center fs-13px">SERIE</label>
                                    </div>
                                </div>

                                <div className="col-md-3">
                                    <form className="form-floating mb-3 mb-md-0">
                                        <input
                                            type="number"
                                            className="form-control fs-15px"
                                            placeholder="1"
                                            onChange={handleInputChange}
                                            name="proximo_correlativo"
                                            value={datos.proximo_correlativo || ""}
                                        />
                                        <label className="d-flex align-items-center fs-13px">PROXIMO CORRELATIVO</label>
                                    </form>
                                </div>

                                <div className="col-md-3">
                                    <form className="form-floating mb-3 mb-md-0">
                                        <input
                                            type="number"
                                            className="form-control fs-15px"
                                            placeholder="100"
                                            onChange={handleInputChange}
                                            name="ultimo_correlativo"
                                            value={datos.ultimo_correlativo || ""}
                                        />
                                        <label className="d-flex align-items-center fs-13px">ULTIMO CORRELATIVO</label>
                                    </form>
                                </div>
                            </div>

                            <div className="row mb-md-4">
                                <div className="col-md-3">
                                    <form className="form-floating mb-3 mb-md-0">
                                        <select
                                            className="form-select"
                                            value={datos.tipoComprobanteId}
                                            onChange={handleInputChange}
                                            name="tipoComprobanteId">
                                            {_.map(tipocomprobantes, (item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.name}
                                                </option>
                                            ))}
                                        </select>
                                        <label className="d-flex align-items-center fs-13px">TIPO DE COMPROBANTE</label>
                                    </form>
                                </div>

                                <label className="form-label col-form-label col-md-2">REGISTRAR TALONARIO COMO: </label>
                                <div className="col-md-3">
                                    <div className="form-check mt-2 mb-2">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            onChange={handleCheckboxChange}
                                            name="activo"
                                            checked={datos.activo || false}
                                        />
                                        <label className="form-check-label">ACTIVO</label>
                                    </div>
                                    <div className="form-check mb-2">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            onChange={handleCheckboxChange}
                                            name="predeterminado"
                                            checked={datos.predeterminado || false}
                                        />
                                        <label className="form-check-label" htmlFor="flexCheckChecked">
                                            PREDETERMINADO
                                        </label>
                                    </div>

                                    <div className="form-check mb-2">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            onChange={handleCheckboxChange}
                                            name="dte"
                                            checked={datos.dte || false}
                                        />
                                        <label className="form-check-label" htmlFor="flexCheckChecked">
                                            DTE (DOCUMENTO TRIBUTARIO ELECTRONICO)
                                        </label>
                                    </div>
                                </div>
                            </div>

                            {datos.dte == 0 ? <hr /> : <></>}

                            {talonario_id != 0 && datos.dte == 0 ? (
                                <div className="row ">
                                    <h3>Template</h3>

                                    <div className="row justify-content-md-center mb-3">
                                        <div className="col-md-6 col-12">
                                            <input
                                                className="form-control"
                                                type="file"
                                                accept="image/png,image/jpeg,image/jpg"
                                                onChange={saveFile}
                                                name="invoice"
                                            />
                                        </div>
                                    </div>

                                    <div className="row justify-content-md-center mb-3">
                                        <div className="col-md-4">
                                            <form className="form-floating mb-3 mb-md-0">
                                                <input
                                                    disabled
                                                    type="text"
                                                    className="form-control fs-15px"
                                                    placeholder="100"
                                                    onChange={handleInputChange}
                                                    name="template_path"
                                                    value={datos.template_path || ""}
                                                />
                                                <label className="d-flex align-items-center fs-13px">TEMPLATE NAME</label>
                                            </form>
                                        </div>
                                        <div className="col-md-2 col-6">
                                            <form className="form-floating mb-3 mb-md-0">
                                                <input
                                                    type="number"
                                                    className="form-control fs-15px"
                                                    placeholder="100"
                                                    onChange={handleInputChange}
                                                    name="template_height"
                                                    value={datos.template_height || ""}
                                                />
                                                <label className="d-flex align-items-center fs-13px">ALTO (cm)</label>
                                            </form>
                                        </div>
                                        <div className="col-md-2 col-6">
                                            <form className="form-floating mb-3 mb-md-0">
                                                <input
                                                    type="number"
                                                    className="form-control fs-15px"
                                                    placeholder="100"
                                                    onChange={handleInputChange}
                                                    name="template_witdh"
                                                    value={datos.template_witdh || ""}
                                                />
                                                <label className="d-flex align-items-center fs-13px">ANCHO (cm)</label>
                                            </form>
                                        </div>
                                    </div>

                                    <div className="col-md-12 text-center ">
                                        <button className="btn btn-inverse btn-lg ms-5px mb-2" onClick={uploadFile}>
                                            <i className="fas fa-upload fa-fw"></i> Subir diseño de comprobante
                                        </button>
                                    </div>

                                    {/* <div className='col-md-2'>
											<img alt="Character" className="main-image"  src={"http://localhost:3030/api/file/download/" + datos.template_path} />
										</div> */}
                                </div>
                            ) : null}

                            {datos.dte == 0 ? <hr /> : <></>}
                            {datos.dte == 0 ? <br /> : <></>}

                            {datos.dte == 0 ? (
                                <div className="row">
                                    <h3>Parametrizacion - Template</h3>
                                    <div className="col-md-10">
                                        <div className="row">
                                            <div className="col-6 col-md-2 mb-2">
                                                <label className="form-label">CAMPO</label>
                                                <select
                                                    className="form-select"
                                                    value={detalleInput.campo}
                                                    onChange={handleInputDetalle}
                                                    name="campo">
                                                    {_.map(camposDisponibles, (item) => (
                                                        <option key={item.value} value={item.value}>
                                                            {item.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="col-6 col-md-1 mb-2">
                                                <label className="form-label">TOP (cm)</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    onChange={handleInputDetalle}
                                                    name="top"
                                                    value={detalleInput.top}
                                                />
                                            </div>

                                            <div className="col-6 col-md-2 mb-2">
                                                <label className="form-label">LEFT (cm)</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    onChange={handleInputDetalle}
                                                    name="left"
                                                    value={detalleInput.left}
                                                />
                                            </div>

                                            <div className="col-6 col-md-2 mb-2">
                                                <label className="form-label">WIDTH (cm)</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    onChange={handleInputDetalle}
                                                    name="width"
                                                    value={detalleInput.width}
                                                />
                                            </div>

                                            <div className="col-6 col-md-2 mb-2">
                                                <label className="form-label">lineHeight (cm)</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    onChange={handleInputDetalle}
                                                    name="lineHeight"
                                                    value={detalleInput.lineHeight}
                                                />
                                            </div>

                                            <div className="col-6 col-md-1 mb-2">
                                                <label className="form-label">BORDER</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    onChange={handleInputDetalle}
                                                    name="border"
                                                    value={detalleInput.border}
                                                />
                                            </div>

                                            <div className="col-6 col-md-2 ">
                                                {editRowIndex >= 0 ? (
                                                    <div>
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary m-r-5 mt-2 ms-1"
                                                            onClick={handleInputEdit}>
                                                            <i className="fa fa-edit"></i>
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn btn-danger m-r-5 mt-2 ms-1"
                                                            onClick={() => setEditRowIndex(-1)}>
                                                            <i className="fa fa-ban"></i>
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <button
                                                        type="button"
                                                        className="btn btn-success  m-r-5 mt-2"
                                                        onClick={handleInputAdd}>
                                                        <i className="fa fa-plus"></i>
                                                    </button>
                                                )}
                                            </div>
                                        </div>

                                        <TablaParametrosTalonario detalle={detalle} actionRow={ActionRowHandler} />
                                    </div>
                                </div>
                            ) : null}
                        </PanelBody>

                        <PanelFooter className="text-center border-1">
                            <a onClick={loadTemplate} className="btn btn-indigo btn-lg ms-5px mb-2">
                                Mostrar Template
                            </a>

                            <Link className="btn btn-default btn-lg ms-5px mb-2" to={"/parametros/talonario"}>
                                Cancelar
                            </Link>
                            {talonario_id == "nuevo" ? null : (
                                <a href="#" className="btn btn-danger btn-lg ms-5px mb-2">
                                    Borrar Registro
                                </a>
                            )}
                            <a onClick={handleSave} className="btn btn-primary btn-lg ms-5px mb-2">
                                Guardar Registro
                            </a>
                        </PanelFooter>
                    </Panel>
                </div>
            </div>
        </div>
    );
};

export default DatosTalonario;
